import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/custom-layout/custom-layout.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
